import React from 'react';
import { StarIcon } from 'lucide-react';
import { useConsultationForm } from './ConsultationFormContext';
export function HeroSection() {
  const {
    openForm
  } = useConsultationForm();
  return <section className="relative min-h-[90vh] flex items-center pt-20 pb-16 overflow-hidden" data-id="element-150">
      {/* Parallax Background Placeholder */}
      <div className="absolute inset-0 z-0 bg-[linear-gradient(to_bottom_right,#F5EBE1,#FAF8F5)]" style={{
      backgroundAttachment: 'fixed',
      backgroundPosition: 'center',
      backgroundSize: 'cover'
    }} data-id="element-151">
        {/* Subtle texture overlay */}
        <div className="absolute inset-0 opacity-30 bg-[radial-gradient(circle_at_center,_var(--tw-gradient-stops))] from-white/40 to-transparent" data-id="element-152"></div>
      </div>

      <div className="container relative z-10 mx-auto px-4 md:px-8 flex flex-col items-center text-center max-w-4xl" data-id="element-153">
        <span className="text-sage font-semibold tracking-[0.2em] uppercase text-xs md:text-sm mb-6 animate-fade-in-up" style={{
        animationDelay: '0.1s'
      }} data-id="element-154">
          RF Microneedling · Be Clinical San Ramon
        </span>

        <h1 className="font-serif text-4xl md:text-6xl lg:text-7xl text-text-dark leading-tight mb-6 animate-fade-in-up" style={{
        animationDelay: '0.3s'
      }} data-id="element-155">
          Your Collagen.
          <br className="hidden md:block" data-id="element-156" /> Your Results. Your Face.
        </h1>

        <p className="text-text-dark/80 text-base md:text-lg lg:text-xl max-w-2xl mb-10 leading-relaxed animate-fade-in-up" style={{
        animationDelay: '0.5s'
      }} data-id="element-157">
          RF Microneedling triggers your body's own collagen production —
          tightening, smoothing, and lifting from within. No injections. No
          filler. Nothing added.
        </p>

        <div className="w-full md:w-auto animate-fade-in-up" style={{
        animationDelay: '0.7s'
      }} data-id="element-158">
          <button onClick={openForm} className="w-full md:w-auto bg-gold hover:bg-[#A6844E] text-white font-bold uppercase tracking-wider px-8 py-4 rounded-sm transition-all duration-300 min-h-[48px] shadow-lg shadow-gold/20" data-id="element-159">
            Book Your Free Consultation
          </button>
        </div>

        {/* Trust Bar */}
        <div className="mt-12 flex flex-col md:flex-row items-center justify-center gap-3 md:gap-6 text-sm text-text-dark/70 animate-fade-in-up" style={{
        animationDelay: '0.9s'
      }} data-id="element-160">
          <div className="flex flex-col items-center gap-2" data-id="element-161">
            <div className="flex items-center gap-1 text-gold" data-id="element-162">
              {[...Array(5)].map((_, i) => <StarIcon key={i} size={16} fill="currentColor" strokeWidth={0} data-id="element-163" />)}
            </div>
            <div className="flex items-center gap-2 md:gap-4 text-xs md:text-sm" data-id="element-164">
              <span data-id="element-165">250+ Reviews</span>
              <span className="w-1 h-1 rounded-full bg-divider" data-id="element-166"></span>
              <span data-id="element-167">4.9 Stars</span>
              <span className="w-1 h-1 rounded-full bg-divider" data-id="element-168"></span>
              <span data-id="element-169">San Ramon, CA</span>
            </div>
          </div>
        </div>
      </div>
    </section>;
}